import { Routes, Route, Outlet } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Clients } from './pages/Clients/Clients';
import Schedule from './pages/Schedule/Schedule';
import { Suggestions } from './pages/Suggestions/Suggestions';
import { Settings } from './pages/Settings/Settings';
import { ErrorBoundary } from './components/Common/ErrorBoundary';
import { ProtectedRoute } from './components/Common/ProtectedRoute';
import { Login } from './pages/Auth/Login';
import { AuthCallback } from './pages/Auth/AuthCallback';

const ProtectedLayout: React.FC = () => (
  <ProtectedRoute>
    <Layout>
      <Outlet />
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/suggestions" element={<Suggestions />} />
          <Route path="/settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<div className="p-8 text-center">Page non trouvée</div>} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;